import React from 'react'
import { observer } from 'mobx-react-lite'

import { useGlobalCopyStore, useGlobalUiStore } from '../context'

import { DateRangeSelector } from './daterangeselector'
import { CalendarActions, DateRangeSelectorCopy } from './daterangeselector/DateRangeSelector'

interface WidgetDateRangeSelectorProps {
  calendarActions: CalendarActions
  dateRange?: { start: Date; end: Date }
  dateRangeVariant?: 'outlined' | 'text' | 'readonly' | 'timeframebuttons' | 'timeframetabs'
}

export const WidgetDateRangeSelector: React.FC<WidgetDateRangeSelectorProps> = observer(
  ({ calendarActions, dateRange, dateRangeVariant }) => {
    const { displayedDateRange } = useGlobalUiStore()
    const { common: commonCopy } = useGlobalCopyStore()

    const dateRangeSelectorCopy = {
      dateRangePickerCopy: {
        dateRangeFrom: commonCopy.date_range_picker.from,
        dateRangeTo: commonCopy.date_range_picker.to,
        dateRangeCustom: commonCopy.date_range_picker.custom,
        dateRangeSelectARange: commonCopy.date_range_picker.select_range,
        dateRangeThisMonth: commonCopy.date_range_picker.this_month,
        dateRangeLastMonth: commonCopy.date_range_picker.last_month,
        dateRangeLast30Days: commonCopy.date_range_picker.last_30_days,
        dateRangeLast90Days: commonCopy.date_range_picker.last_90_days,
        dateRangeYTD: commonCopy.date_range_picker.ytd,
        dateRangeLastYear: commonCopy.date_range_picker.last_year,
        dateRangeSelect: commonCopy.date_range_picker.select,
      },
      dateRangeEditApply: commonCopy.date_range_picker.edit_apply,
      dateRangeEditTitle: commonCopy.date_range_picker.edit_title,
      dateRangeNextAria: commonCopy.date_range_picker.next_aria,
      dateRangePreviousAria: commonCopy.date_range_picker.previous_aria,
    } as DateRangeSelectorCopy

    const startDate = dateRange ? dateRange.start : displayedDateRange.start
    const endDate = dateRange ? dateRange.end : displayedDateRange.end

    return (
      <DateRangeSelector
        calendarActions={calendarActions}
        copy={dateRangeSelectorCopy}
        range={[startDate, endDate]}
        shouldShrinkToIcon={false}
        variant={dateRangeVariant}
      />
    )
  },
)
